import {Link} from "react-router-dom";

export default function MainBlockNewsDetail(props) {
    return (
        <section className="main_block news_details">
            <div className="container">
                <div className="bread_crumbs">
                    <div>
                        <Link to="/">Главная</Link>
                    </div>
                    <div>></div>
                    <div>Новости</div>
                </div>
                <h1>
                    <span className="title main_title main_title_news_detail">{props.title}</span>
                </h1>
            </div>
        </section>
    )
}
